export default __webpack_public_path__ + "static/media/Joana_2.677e4cfe.webp";